<template>
  <!-- review heading -->
  <div class="d-flex flex-column flex-sm-row">
    <!-- avatar -->
    <div class="avatar me-2">
      <div class="avatar__letters">
        {{ review.user.display_name[0].toUpperCase() }}
      </div>
      <div v-if="review.verified_buyer" class="verified-avatar-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path
            d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z"
          />
        </svg>
      </div>
    </div>
    <!-- username/date -->
    <div class="w-100 pt-2">
      <p class="h5 d-inline text-capitalize">
        {{ review.user.display_name }}
      </p>
      <p class="d-inline ms-2">
        <small v-if="review.verified_buyer">Verified Buyer</small>
      </p>

      <p class="float-end mb-0">
        <small>{{ review.readableDate }}</small>
      </p>
    </div>
  </div>
  <!-- stars -->
  <div class="ps-md-5">
    <ReviewStars :numStars="review.score" size="small" />
  </div>
  <!-- review title/content -->
  <div class="ps-md-5 mt-3">
    <p class="h6">{{ review.title }}</p>
  </div>
  <!-- review content -->
  <div class="ps-md-5">
    <p>
      {{
        review.truncated
          ? review.expanded
            ? review.content
            : review.truncatedDescrip
          : review.content
      }}<button
        v-if="review.truncated"
        class="read-more"
        v-bind:class="{ 'margin-left': review.expanded }"
        @click="expandDescription(review)"
      >
        {{ review.expanded ? 'Read Less' : '...Read More' }}
      </button>
    </p>
  </div>
  <!-- custom fields data/images -->
  <div class="ps-md-5 d-flex flex-column flex-md-row justify-content-between">
    <!-- custom questions -->
    <div class="mb-3">
      <p v-for="(value, key) in review.custom_fields" class="mb-0" :key="key">
        <small v-if="value.title === 'Comfort'"><strong>{{ value.title }}:</strong> {{ translateAllpaComfortLevel(value.value) }}</small>
        <small v-else><strong>{{ value.title }}:</strong> {{ value.value }}</small>
      </p>
    </div>
    <!-- images -->
    <div class="d-flex align-items-center flex-wrap ms-1">
      <img
        v-for="(image, index) in review.images_data"
        :key="image.id"
        class="review-img"
        :src="image.thumb_url"
        @click="showFullImg(index)"
        @error="imgError(index)"
      />
    </div>
  </div>
  <!-- coto response -->
  <div v-if="review.comment">
    <div class="d-flex align-items-end ps-sm-5 mt-2">
      <!-- avatar -->
      <div
        class="avatar"
        v-bind:style="{
          background: review.comment.comments_avatar
            ? 'url(' + review.comment.comments_avatar + ')'
            : '#f9461c',
          backgroundSize: 'auto 100%',
        }"
      ></div>
      <!-- display name -->
      <p class="h5 d-inline ps-2">
        {{ review.comment.display_name }}
      </p>
    </div>
    <!-- response -->
    <p class="ps-sm-5 mt-2">
      {{ review.comment.content }}
    </p>
  </div>
  <!-- was this review helpful -->
  <ReviewHelpful
    :reviewId="review.id"
    :votesUp="review.votes_up"
    :votesDown="review.votes_down"
  />

  <!-- Image Modal -->
  <div
    class="review-modal-container"
    v-if="showModal"
    @click="showModal = false"
  >
    <div class="review-modal" v-show="showModal" v-on:click.stop>
      <div class="review-modal-close" @click="showModal = false">X</div>
      <swiper
        :modules="modules"
        :slides-per-view="1"
        :space-between="50"
        :lazy="true"
        navigation
        @slideChange="onSlideChange"
      >
        <swiper-slide v-for="(img, index) in review.images_data" :key="img.id">
          <img
            class="d-block mx-auto"
            :src="img.original_url"
            itemprop="image"
          />
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script src="./ctrl-review-card.js"></script>
